import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const AtlassianDataLake = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/platform/analytics"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianDataLake.header",
            defaultMessage: "Atlassian Data Lake"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AtlassianDataLake.body",
            defaultMessage:
                "Access fully modeled data across your Atlassian tools in one place."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AtlassianDataLake.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about Atlassian Data Lake."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default AtlassianDataLake;
